import React from 'react';
import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
    },
    modalImage: {
        backgroundColor: '#FFFFFF',
        borderRadius: ".5rem",
        padding: "1rem",
        maxWidth: "90%",
        maxHeight: "90vh",
        objectFit: "contain",
    },
});

const ImageModal = ({
    classes,
    isOpen,
    imageUrl,
    onClose,
    currentLanguage
}) => {
    if (!isOpen) return null;

    return (
        <Box
            className={classes.modalOverlay}
            onClick={onClose}
        >
            <img
                src={imageUrl}
                alt={currentLanguage.bepiService.shared.shared_image_modal_alt}
                className={classes.modalImage}
                onClick={(e) => e.stopPropagation()}
            />
        </Box>
    );
};

export default withStyles(styles)(ImageModal);
